'use client';
import React from 'react';
import RenderFormFields from 'src/components/era-package/forms/RenderFormFields';

const ImportManifestInfo = ({ formData, setFormData }) => {
  const fields = [
    {
      name: 'importManifestInfo',
      label: 'Import Manifest Info',
      type: 'toggle',
      maxLength: undefined,
      placeholder: '',
      defaultValue: false,
      sizeProp: { xs: 12 },
      required: false,
      disabled: false,
      icon: undefined,
    },
  ];

  return (
    <RenderFormFields
      fields={fields}
      formData={formData || {}}
      setFormData={setFormData}
    />
  );
};

export default ImportManifestInfo;